import { createBrowserHistory } from 'history';

// Keep routing and unsaved-edit blockers on the same history instance.
export const browserHistory = createBrowserHistory();
